import useTranslate from '@core/hooks/useTranslate';
import { ADMIN_SELLER_MENU } from '@root/core/constants/Seller/seller-menu';
import SellersPage from '@root/modules/Sellers/Dashboard/pages/SellersPage';
import SellerForwarding from '@root/modules/Sellers/Forwarding/pages/SellerForwarding';
import ImportManagement from '@root/modules/Sellers/Import/pages/Import';
import ImportDetailPage from '@root/modules/Sellers/Import/pages/ImportDetailPage';
import ImportStock from '@root/modules/Sellers/Import/pages/ImportStock';
import InquiryDetailPage from '@root/modules/Sellers/Inquiry/pages/InquiryDetailPage';
import InquiryPage from '@root/modules/Sellers/Inquiry/pages/InquiryPage';
import MessageDetail from '@root/modules/Sellers/Message-Detail/pages/MessageDetail';
import SellerMessage from '@root/modules/Sellers/Message/pages/SellerMessage';
import InfoAmazon from '@root/modules/Sellers/Mypage/components/info-amazon';
import Mypage from '@root/modules/Sellers/Mypage/pages/Mypage';
import SellerProduct from '@root/modules/Sellers/Product/pages/Product';
import ProductDetailPage from '@root/modules/Sellers/Product/pages/ProductDetail';
import RequestProduct from '@root/modules/Sellers/Return/pages/Request';
import ReturnDetailPage from '@root/modules/Sellers/Return/pages/return-not-access/ReturnDetailPage';
import ReturnNotAccess from '@root/modules/Sellers/Return/pages/return-not-access/ReturnNotAccess';
import ReturnDetailCancel from '@root/modules/Sellers/Return/pages/ReturnDetailCancel';
import SettlementDetail from '@root/modules/Sellers/Settlement/pages/SettlementDetail';
import SettlementList from '@root/modules/Sellers/Settlement/pages/SettlementList';
import CreateShipping from '@root/modules/Sellers/Shipping/page/CreateShipping';
import CreateShippingReturn from '@root/modules/Sellers/Shipping/page/CreateShippingReturn';
import Shipping from '@root/modules/Sellers/Shipping/page/Shipping';
import ShippingDetail from '@root/modules/Sellers/Shipping/page/ShippingDetail';
import ShippingRequestCSV from '@root/modules/Sellers/Shipping/page/ShippingRequestCSV';
import ShippingReturnDisposal from '@root/modules/Sellers/Shipping/page/ShippingReturnDisposal';
import ShippingReturnDisposalDetail from '@root/modules/Sellers/Shipping/page/ShippingReturnDisposalDetail';
import ShippingReturnRequest from '@root/modules/Sellers/Shipping/page/ShippingReturnRequest';
import ShippingReturnRequestDetail from '@root/modules/Sellers/Shipping/page/ShippingReturnRequestDetail';
import ShippingReturnTracking from '@root/modules/Sellers/Shipping/page/ShippingReturnTracking';
import ShippingReturnTrackingDetail from '@root/modules/Sellers/Shipping/page/ShippingReturnTrackingDetail';
import UpdateShipping from '@root/modules/Sellers/Shipping/page/UpdateShipping';
import Stock from '@root/modules/Sellers/Stock/page/Stock';
import StockDetail from '@root/modules/Sellers/Stock/page/StockDetail';
import StockWarehouse from '@root/modules/Sellers/Stock/page/StockWarehouse';
import { Layout, Menu } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, Redirect, Route, Switch, useLocation } from 'react-router-dom';

const { Sider, Content } = Layout;
interface Props {
  path?: string;
}

const SellerSidebar = ({ path = '' }: Props) => {
  const [t] = useTranslate();
  const [collapsed, setCollapsed] = useState(false);
  const [selected, setSeclected] = useState('');
  const [a, setA] = useState([] as any);
  const activeItem = (event: any) => {
    setSeclected(event.key);
  };
  const location = useLocation();

  useEffect(() => {
    let a = location;
    const b = a.pathname.replace('/admin/', '').split('/');
    setA(b);
  }, [location]);

  const colorParent = (item: {
    id: number;
    name?: string;
    label?: string;
    url: string;
    children?: { id: number; name: string; url: string }[];
  }) => {
    let isBold =
      !a[1] && item.url == '/admin/seller'
        ? 'bold'
        : a[1] == item.url.replace('/admin/seller/', '')
        ? 'bold'
        : !!a[1] &&
          a[1]
            .replace('/admin/seller/', '')
            .split('-')
            .includes(item.url.replace('/admin/seller/', ''))
        ? 'bold'
        : '500';
    return isBold;
  };

  const colorHasChild = (item: {
    id: number;
    name?: string;
    label?: string;
    url?: string;
    children: { id: number; name: string; url: string }[];
  }) => {
    let isbold = false;
    item.children.forEach((child) => {
      let bold =
        !!a[1] && !a[2] && a[1] == child.url.replace('/admin/seller/', '')
          ? true
          : !!a[2] &&
            a[2] == child.url.replace('/admin/seller/' + a[1] + '/', '')
          ? true
          : !!a[2] &&
            child.url.includes(a[1]) &&
            child.url.replace('/admin/seller/', '').split('/')[0].includes(a[1])
          ? true
          : false;
      if (bold) isbold = true;
    });
    return isbold ? 'bold' : '500';
  };

  const renderAdminOrStoreHeader = () => {
    return (
      <>
        <Layout className="navigation">
          <Sider collapsedWidth="48" width="230" className="side-bar__menu">
            <Menu
              mode="inline"
              style={{ height: '100%', borderRight: 0 }}
              selectedKeys={[path]}
            >
              {ADMIN_SELLER_MENU.map((item: any, index: number) => (
                <>
                  {item.children ? (
                    <Menu.SubMenu
                      title={item.label}
                      key={index + 200}
                      style={{ fontWeight: colorHasChild(item) }}
                    >
                      {item.children.map((child: any, idx: number) => (
                        <>
                          {child.children ? (
                            <Menu.SubMenu
                              title={child.label}
                              key={index + 400}
                              style={{ fontWeight: colorHasChild(child) }}
                            >
                              {child.children.map(
                                (childChild: any, childChildIdx: number) => (
                                  <Menu.Item
                                    key={idx + index * 10 + childChildIdx * 10}
                                  >
                                    <Link
                                      to={childChild.url}
                                      style={{
                                        fontWeight:
                                          childChild.url ===
                                            location.pathname ||
                                          (childChild.hiddenChildren &&
                                            childChild.hiddenChildren.find(
                                              (h: any) =>
                                                h.url === location.pathname ||
                                                h.url.test(location.pathname)
                                            ))
                                            ? 'bold'
                                            : '500'
                                      }}
                                    >
                                      {t(childChild.name)}
                                    </Link>
                                  </Menu.Item>
                                )
                              )}
                            </Menu.SubMenu>
                          ) : (
                            <Menu.Item key={idx + index * 10}>
                              <Link
                                to={child.url}
                                style={{
                                  fontWeight:
                                    !!a[1] &&
                                    !a[2] &&
                                    a[1] ==
                                      child.url.replace('/admin/seller/', '')
                                      ? 'bold'
                                      : (!!a[2] &&
                                          (a[2] ==
                                            child.url.replace(
                                              '/admin/seller/' + a[1] + '/',
                                              ''
                                            ) ||
                                            (!isNaN(a[2]) &&
                                              child.url.replace(
                                                '/admin/seller/' + a[1],
                                                ''
                                              ) == ''))) ||
                                        (child.hiddenChildren &&
                                          child.hiddenChildren
                                            .map((v: any) => v.url)
                                            .includes(location.pathname))
                                      ? 'bold'
                                      : '500'
                                }}
                              >
                                {t(child.name)}
                              </Link>
                            </Menu.Item>
                          )}
                        </>
                      ))}
                    </Menu.SubMenu>
                  ) : (
                    <Menu.Item
                      className={'menu-nav'}
                      title={item.label}
                      onClick={(event) => activeItem(event)}
                      key={index + 300}
                    >
                      <Link
                        key={item.id + 1000}
                        to={item.url}
                        style={{
                          color:
                            selected === `tmp_key-${index}` ? '#0077ff' : '',
                          fontWeight: colorParent(item)
                        }}
                      >
                        {t(item.name)}
                      </Link>
                    </Menu.Item>
                  )}
                </>
              ))}
            </Menu>
          </Sider>
          <Layout>
            <Content
              style={{
                minHeight: 280,
                minWidth: 1080,
                overflow: 'scroll'
              }}
            >
              <Switch>
                <Route exact path="/admin/seller">
                  <SellersPage />
                </Route>
                <Route exact path="/admin/seller/quote">
                  <InquiryPage />
                </Route>
                <Route path="/admin/seller/quote/:productId">
                  <InquiryDetailPage />
                </Route>
                <Route exact path="/admin/seller/product">
                  <SellerProduct />
                </Route>
                <Route path="/admin/seller/product/:productId">
                  <ProductDetailPage />
                </Route>
                <Route exact path="/admin/seller/stock">
                  <Stock />
                </Route>
                <Route path="/admin/seller/stock/:stockId">
                  <StockWarehouse />
                </Route>
                <Route path="/admin/seller/stock-detail/:productId">
                  <StockDetail />
                </Route>
                <Route exact path="/admin/seller/shipping">
                  <Shipping />
                </Route>
                <Route exact path="/admin/seller/shipping/return-tracking">
                  <ShippingReturnTracking />
                </Route>
                <Route
                  exact
                  path="/admin/seller/shipping/return-tracking/:productId"
                >
                  <ShippingReturnTrackingDetail />
                </Route>
                <Route exact path="/admin/seller/shipping/return-request">
                  <ShippingReturnRequest />
                </Route>
                <Route
                  exact
                  path="/admin/seller/shipping/return-request/:productId"
                >
                  <ShippingReturnRequestDetail />
                </Route>
                <Route exact path="/admin/seller/shipping/return-disposal">
                  <ShippingReturnDisposal />
                </Route>
                <Route
                  exact
                  path="/admin/seller/shipping/return-disposal/:productId"
                >
                  <ShippingReturnDisposalDetail />
                </Route>
                <Route exact path="/admin/seller/shipping/create-return">
                  <CreateShippingReturn />
                </Route>
                <Route
                  exact
                  path="/admin/seller/shipping/edit/:shippingid/:commentId"
                >
                  <UpdateShipping />
                </Route>
                <Route path="/admin/seller/shipping/:shippingid">
                  <ShippingDetail />
                </Route>
                <Route exact path="/admin/seller/shipping-create">
                  <CreateShipping />
                </Route>
                <Route exact path="/admin/seller/shipping-create/csv">
                  <ShippingRequestCSV />
                </Route>
                <Route path="/admin/seller/import/stock">
                  <ImportStock />
                </Route>
                <Route exact path="/admin/seller/import">
                  <ImportManagement />
                </Route>
                <Route exact path="/admin/seller/import/:productId">
                  <ImportDetailPage />
                </Route>
                <Route exact path="/admin/seller/return">
                  <ReturnNotAccess />
                </Route>
                <Route exact path="/admin/seller/return/:productId">
                  <ReturnDetailPage />
                </Route>
                <Route exact path="/admin/seller/return-disposal">
                  <ReturnNotAccess />
                </Route>
                <Route exact path="/admin/seller/return-disposal/:productId">
                  <ReturnDetailPage />
                </Route>
                <Route exact path="/admin/seller/settlement">
                  <SettlementList />
                </Route>
                <Route path="/admin/seller/settlement/:id">
                  <SettlementDetail />
                </Route>
                <Route exact path="/admin/seller/request">
                  <ReturnDetailCancel />
                </Route>
                <Route path="/admin/seller/request/:id">
                  <RequestProduct />
                </Route>
                <Route exact path="/admin/seller/mypage">
                  <Mypage />
                </Route>
                <Route exact path="/admin/seller/forwarding">
                  <SellerForwarding />
                </Route>
                <Route exact path="/admin/seller/message">
                  <SellerMessage />
                </Route>
                <Route exact path="/admin/seller/message/:id">
                  <MessageDetail />
                </Route>
                <Route path="">
                  <Redirect to="/admin/seller" />
                </Route>
              </Switch>
            </Content>
          </Layout>
        </Layout>
      </>
    );
  };

  return renderAdminOrStoreHeader();
};

export default React.memo(SellerSidebar);
